import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import { Meta, Title } from "@angular/platform-browser";

@Component({
  selector: 'error-network',
  templateUrl: './network.component.html'
})

export class ErrorNetworkComponent {
  constructor(private router: Router){
  }
}
